import { mediaQueryLarge, requestIdleCallback } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#setLayout(target.value);

    requestIdleCallback(() => {
      try {
        const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
        sessionStorage.setItem(`product-grid-view-${viewport}`, target.value);
      } catch (error) {
        console.warn('No se pudo guardar la vista del grid:', error);
      }
    });
  }

  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;

    grid.setAttribute('product-grid-view', value);
  }

  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}